import React           from 'react';
import styled          from 'styled-components';
import { Button }      from '@material-ui/core';
import { ButtonProps } from '@material-ui/core/Button';

interface IProps extends ButtonProps {
  label?           : string;
  width?           : string;
  margin?          : string;
  bgcolor?         : string;
  textcolor?       : string;
  onClick?         : (props?: any) => void;
}

const StyledButton = styled(Button)<{ isLayoutChanged?: boolean }>` && {
  position  : absolute;
  left      : 50%;
  transform : translate(-50%, -50%);
  width     : 80%;
}`;

const Wrapper = styled.div`
  position       : relative;
  width          : 100%;
  height         : 0;
  padding-bottom : 10%;
`;

export const WithoutWidthButton: React.FC<IProps> = ({ ...props }) => (
  <Wrapper>
    <StyledButton {...props}>
      {props.children ?? props.label}
    </StyledButton>
  </Wrapper>
);

WithoutWidthButton.defaultProps = {
  color         : 'secondary',
  variant       : 'contained',
  disableRipple : true,
};
